import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCardText, [_vm.deletePrompt ? _c('core-prompt', {
    attrs: {
      "data-cy": "prompt_delete_user",
      "title": _vm.$i18n_t('accMgmt.user.confirmDeleteUser'),
      "open": _vm.deletePrompt,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        dataCy: 'btn_cancel',
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        dataCy: 'btn_delete',
        color: 'red',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.doDeleteUser(_vm.deletionModel);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.deletionModel.email) + "\n  ")]) : _vm._e(), _vm.loading ? [_c(VSkeletonLoader, {
    attrs: {
      "type": "table-thead"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-2",
    attrs: {
      "type": "table-row-divider@5"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-auto",
    attrs: {
      "type": "table-tfoot"
    }
  })] : [_vm.canImpersonateUser && _vm.isImpersonating ? _c(VAlert, {
    staticClass: "mb-1 mt-0 py-2",
    attrs: {
      "color": "transparent",
      "icon": "fal fa-comment-exclamation"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('accMgmt.tenant.impersonateUserDisabled')) + "\n    ")]) : _vm._e(), _c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalized.headers,
      "items": _vm.userList,
      "server-items-length": _vm.serverItemsLength,
      "expanded": _vm.expandedItems,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableLocalized.footerProps,
      "item-key": "email",
      "page": _vm.tableOptions.page,
      "must-sort": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "200px"
          },
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_vm.selectedTenantId ? _c('router-link', {
          attrs: {
            "to": `/account-mgmt/user/${_vm.selectedTenantId}/${props.item.id}`
          }
        }, [_vm._v("\n              " + _vm._s(props.item.lastName) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(props.item.lastName) + "\n            ")])], 1), _c('td', {
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "190px"
          },
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_vm.selectedTenantId ? _c('router-link', {
          attrs: {
            "to": `/account-mgmt/user/${_vm.selectedTenantId}/${props.item.id}`
          }
        }, [_vm._v("\n              " + _vm._s(props.item.firstName) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(props.item.firstName) + "\n            ")])], 1), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_vm._v(_vm._s(props.item.email))]), _c('td', {
          staticClass: "text-center",
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(props.item.active ? 'check' : 'times'))])], 1), _vm.hasUserManagePermission || _vm.hasImpersonatePermission ? _c('td', {
          staticClass: "text-right",
          staticStyle: {
            "min-width": "128px"
          }
        }, [props.item.active && _vm.canImpersonateUser(props.item) && props.item.id !== _vm.user.id ? [!_vm.isImpersonating ? _c(VIcon, {
          attrs: {
            "data-cy": "impersonate_user",
            "color": _vm.color,
            "title": _vm.$i18n_t('accMgmt.tenant.impersonateUser'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.doImpersonateUser(props.item);
            }
          }
        }, [_vm._v("\n                fal fa-user-ninja\n              ")]) : _c(VIcon, {
          staticStyle: {
            "opacity": "0.6"
          },
          attrs: {
            "title": _vm.$i18n_t('accMgmt.tenant.impersonateUserDisabled'),
            "color": "primary",
            "small": ""
          }
        }, [_vm._v("\n                fal fa-user-ninja\n              ")])] : _vm._e(), _vm.canManageUser(props.item) ? [_vm._v("\n               \n              "), _c(VIcon, {
          attrs: {
            "data-cy": "edit_user",
            "data-cy-edit-user": props.item.email,
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editUser(props.item);
            }
          }
        }, [_vm._v("\n                fal fa-edit\n              ")]), _vm._v("\n               \n              "), _c(VIcon, {
          attrs: {
            "data-cy": "delete_user",
            "data-cy-delete-user": props.item.email,
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.deletionModel = props.item;
              _vm.deletePrompt = true;
            }
          }
        }, [_vm._v("\n                fal fa-trash-alt\n              ")])] : _vm._e()], 2) : _vm._e()])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "6"
          }
        }, [_vm._l(_vm.accessesForUser(props.item), function (access, i) {
          return _c('div', {
            key: `user_${props.item.id}_access_${i}`
          }, [access && access.scopeId ? [_c('div', {
            class: `px-2 ${access.primary ? 'highlighted' : ''}`
          }, [_c('span', {
            staticStyle: {
              "display": "none"
            }
          }, [_vm._v(_vm._s(_vm.fetchScopeDetails(access.Scope)))]), _c('p', {
            staticClass: "text-overline pt-1 mb-0 grey--text"
          }, [_vm._v("\n                    " + _vm._s((_vm.scopeDetails[access.Scope.id] || {}).crumbPath) + "\n                  ")]), _vm._v("\n                  " + _vm._s((access.roles || []).map(r => r.name).join(', ')) + "\n                ")])] : _vm._e()], 2);
        }), _c('div', {
          staticClass: "mb-4"
        })], 2)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n            " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(props.itemsLength) + "\n          ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n        ")])];
      },
      proxy: true
    }])
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };